<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="车辆管理"
    >
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.table_list"
        v-loading="!Array.isArray(state.table_list)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />

        <el-table-column
          :formatter="(row) => $tab_GroupFormat(row.number, row.name)"
        >
          <template #header>
            <div class="c-table-col-header" label1="车牌号" label2="车型" />
          </template>
        </el-table-column>
        <el-table-column
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.d_car_type_name,
                row.passenger_capacity + '人',
              )
          "
        >
          <template #header>
            <div class="c-table-col-header" label1="类型" label2="核载人数" />
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="司机信息"
              label2="所属公司"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.driver_company">
              <template #top>
                <text>{{ row.driver_name }}</text>
                <text class="text-gray-400">{{ row.driver_phone }}</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="intro"
          label="服务时段"
          :formatter="$tab_TextFormat"
        >
          <template #default="{ row }">
            <text>{{
              $dayjs(row.service_time_start).format("YYYY-MM-DD") +
              " ~ " +
              $dayjs(row.service_time_end).format("YYYY-MM-DD")
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="intro"
          label="说明"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="操作" fixed="right" align="center" :width="160">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="`${state.selectId ? '编辑' : '新建'}车辆`"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
    :width="500"
  >
    <c_info
      :meeting_id="props.meeting_id"
      :meeting_start_date="props.meeting_start_date"
      :meeting_end_date="props.meeting_end_date"
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_car_page, meeting_car_delete } from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_info,
  },
  props: {
    meeting_id: Number,
    meeting_start_date: String, //会议开始时间
    meeting_end_date: String, //会议结束时间
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.table_list;

      meeting_car_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.table_list = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(meeting_car_delete, row.id, onLoad, {
        filed: "会议车辆",
        name: row.name,
      });
    };

    return { state, props, onLoad, onDelete };
  },
};
</script>

<style lang="scss" scoped></style>
